import { useDispatch, useSelector } from 'react-redux';
import { Steps } from 'antd';
import NoteBook from '../shared/assets/images/BookADemo.svg'
import { selectBookDemoData, selectCurrentStepperStep, setBookDemoData, setCurrentStepperStep } from "../modules/ContactUsForm/slice/contactusSlice";
import landingBg from '../shared/assets/images/landingPageAssets/landingBg.svg'
import landingBgMobile from '../shared/assets/images/landingPageAssets/landingBgMobile.svg'
import Footer from '../shared/components/Layout/Footer';
import { BookADemoForm } from '../modules/ContactUsForm/components/BookADemoForm';
import AddDateTimeForm from '../modules/ContactUsForm/components/AddDateTimeForm';
import { BookADemoSteps } from '../shared/utils/interfaces/landingPageFace';
import Nav from '../shared/components/NavBar/Nav';
import { useCookies } from 'react-cookie';
import { useEffect } from 'react';
import blueArrowLeft from '../shared/assets/images/blueArrowLeft.svg'
import { selectSelectedDate, setSelectedDate } from '../shared/components/Calendar/slice/calendarSlice';
import dayjs from 'dayjs';

const BookADemoStepper = () => {
    const currentStep = useSelector(selectCurrentStepperStep);
    const stepperItems = [{ title: '' }, { title: '' }];
    const [cookies] = useCookies(['isActive']);
    const { isActive } = cookies;
    const dispatch = useDispatch();
    const selectedDate = useSelector(selectSelectedDate);
    const bookDemoData = useSelector(selectBookDemoData);

    useEffect(() => {
        return () => {
            dispatch(setCurrentStepperStep(0))
            dispatch(setBookDemoData({}))
            dispatch(setSelectedDate(dayjs().format('YYYY-MM-DD')));
        };
    }, [dispatch]);

    useEffect(() => {        
        if(selectedDate === '' && (bookDemoData?.selectedDate !== null || bookDemoData?.selectedEgyptTimeSlot !== null)) {
            dispatch(setBookDemoData({
                ...bookDemoData,
                selectedDate: null,
                selectedEgyptTimeSlot: null,
            }));
        }
    }, [dispatch, selectedDate, bookDemoData])

    return (
        <main>
            <Nav isPublic = {!isActive} />
            <div className='relative'>
                <div className="absolute inset-0 -z-50">
                    <img alt='PeopleCQ' src={landingBgMobile} className='object-cover w-full pointer-events-none md:hidden' draggable={false} />
                    <img alt='PeopleCQ' src={landingBg} className='hidden object-cover w-full pointer-events-none md:block' draggable={false} />
                </div>
                <div className="flex flex-col items-center justify-center pt-[4.375rem] sm:pt-28 px-6">
                    <div>
                        <div
                            className={`flex items-center gap-[0.625rem] w-full h-[1.875rem] mb-[0.375rem] cursor-pointer ${currentStep === BookADemoSteps.PERSONAL_INFO ? 'invisible' : 'visible'}`}
                            onClick={() => dispatch(setCurrentStepperStep(BookADemoSteps.PERSONAL_INFO))}
                        >
                            <img src={blueArrowLeft} alt="back" className='w-4 h-4' />
                            <div className='text-xs font-medium text-[#4338CA]'>Previous Step</div>
                        </div> 
                        <div className='flex flex-col w-full max-w-lg gap-6 p-6 mb-10 bg-white rounded-lg scrollbar-hide'>
                            <div className="flex flex-col items-center justify-center gap-5">
                                <img src={NoteBook} alt="book a demo" className="w-12 h-12" />
                                <div className="flex flex-col items-center justify-center gap-2">
                                    <div className="text-lg font-medium leading-6 text-center text-gray-900">
                                        Book a Demo With peopleCQ
                                    </div>
                                    <p className="text-sm text-gray-500 text-center max-w-[26rem]">
                                    {currentStep === BookADemoSteps.PERSONAL_INFO ? 'Book a demo today and unlock an extended 30-day free trial on our standard package.'
                                    : 'peopleCQ empowers you to effortlessly create, discover, hire, onboard and manage top tier talent, all in one platform'}
                                    </p>
                                </div>
                            </div>
                            <div>
                                <div className="flex items-center justify-center bookADemo-stepper">
                                    <Steps
                                        responsive={false}
                                        current={currentStep}
                                        items={stepperItems}
                                        className='w-1/2 md:w-1/3'
                                        />
                                </div>
                            </div>
                            {currentStep === BookADemoSteps.PERSONAL_INFO ? <BookADemoForm /> : currentStep === BookADemoSteps.DATE_TIME ? <AddDateTimeForm /> : ""}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </main>
    );
}

export default BookADemoStepper